export function normalizeUserEmail(email) {
  return String(email || '').trim().toLowerCase();
}

export function groupUsersByEmail(users) {
  const groups = new Map();
  (users || []).forEach((user) => {
    const email = normalizeUserEmail(user.email);
    if (!email) return;
    if (!groups.has(email)) groups.set(email, []);
    groups.get(email).push(user);
  });
  return [...groups.entries()]
    .map(([email, list]) => ({ email, users: list }))
    .filter((group) => group.users.length > 1);
}

export function usersSharingEmail(users, emailOrUser) {
  const email = normalizeUserEmail(typeof emailOrUser === 'string' ? emailOrUser : emailOrUser?.email);
  if (!email) return [];
  return (users || []).filter((user) => normalizeUserEmail(user.email) === email);
}

export function pickKeeperAndExtras(users, { keepId } = {}) {
  const list = users || [];
  if (keepId) {
    const keeper = list.find((user) => user.id === keepId) || null;
    return { keeper, extras: list.filter((user) => user.id !== keepId) };
  }
  const approved = list.filter((user) => user.verificationStatus === 'approved');
  if (approved.length === 1) {
    return {
      keeper: approved[0],
      extras: list.filter((user) => user.id !== approved[0].id),
    };
  }
  if (approved.length > 1) {
    return { keeper: null, extras: [], reason: 'multiple_approved' };
  }
  return { keeper: null, extras: [], reason: 'no_approved' };
}

export function canArchiveEmailExtras({ keeper, extras }) {
  if (!keeper) return { ok: false, reason: 'no_keeper' };
  if (keeper.verificationStatus !== 'approved') {
    return { ok: false, reason: 'keeper_not_approved' };
  }
  if (!extras.length) return { ok: false, reason: 'no_extras' };
  if (extras.some((user) => user.verificationStatus === 'approved')) {
    return { ok: false, reason: 'approved_extra' };
  }
  return { ok: true, keeper, extras };
}

/** Do not recreate users/{uid} after that profile was archived on purpose. */
export function shouldCreateMissingUserProfile({ firestoreUser, archivedUser } = {}) {
  if (firestoreUser) return false;
  if (archivedUser) return false;
  return true;
}
